import { getTalkRoom } from './../redux/actions/talkRoomActions';
import { NoteInterface } from './../components/Notes';
import { CONFIG } from "../constants"
import store from '../redux/store'
import { addNoteAction, deleteNoteAction, editNoteAction } from '../redux/actions/notesActions';

export default class WebSocketClient {

  static myInstance: WebSocketClient;
  private token: string;
  private socketOpen: boolean;
  private webSocket?: WebSocket;
  public eventEl: any;
  public unReadMessage: boolean;

  constructor() {
    this.socketOpen = false;
    this.unReadMessage = false;
    this.token = window.localStorage[CONFIG.TOKEN_NAME];

    if (this.token) {
      this.openSocket();
      // console.log('Opening socket, found token');
    } else {
      // console.log('Not opening socket, no token');
    }
    this.eventEl = document.createTextNode('');
  }

  private openSocket() {
    this.webSocket = new WebSocket(CONFIG.WEB_SOCKET_ENDPOINT);
    this.socketOpen = true;
    // console.log('Tried opening websocket');
    this.webSocket.onerror = (err) => {
      this.socketOpen = false;
    };
    const mess = {
      type: 'init',
      token: this.token,
    };

    this.webSocket.onopen = (event) => {
      // console.log('Sending', JSON.stringify(mess));
      if (this.webSocket) {
        this.webSocket.send(JSON.stringify(mess));
      }
    };

    this.webSocket.onmessage = (message) => {
      const jsonMess = JSON.parse(message.data);
      // console.log('Got ', jsonMess);

      if (jsonMess.command === 'participant_count') {
        // console.log('Handle participant_count: ' + jsonMess.participants +', '+ jsonMess.meetingKey)
        store.dispatch(getTalkRoom({
          walk: 0,
          room: jsonMess.meeting_key,
          participant_count: jsonMess.participants
        }))
        return
      } else if (jsonMess.command === 'noteChanged') {
        const payload: NoteInterface = {
          text: jsonMess.text,
          edit: jsonMess.edit,
          json: jsonMess.json,
          noteType: jsonMess.noteType,
          private: jsonMess.private,
          createdAt: jsonMess.createdAt,
          id: jsonMess.id,
          updatedAt: jsonMess.updatedAt,
          walk_id: jsonMess.walk_id,
          person: jsonMess.person
        }
        if(jsonMess.action === 'add') {
          store.dispatch(addNoteAction(payload))
        } else if (jsonMess.action === 'edit') {
          store.dispatch(editNoteAction(payload))
        } else if(jsonMess.action === 'delete') {
          store.dispatch(deleteNoteAction(jsonMess.id))
        }
        return
      } else if (jsonMess.command === 'noteChanged') {
        // console.log('WEBSOCKET noteChanged')
        // console.log(jsonMess)
        return
      }
      console.log(jsonMess.data)

      this.unReadMessage = true;
      this.sendEvent('walkchat', jsonMess.data);
      console.log(jsonMess.data)
      // This is where we handle received message...
      setTimeout(() => {
        // If chat is already open it will set unReadMessage to false.
        if (this.unReadMessage) {
          console.log('sending unread event', jsonMess.data);
          this.sendEvent('unread', jsonMess.data);
        }
      }, 1000);
    };
  }

  public close() {
    this.socketOpen = false;
    if (this.webSocket) {
      this.webSocket.close();
    }

  }

  public detachSocket() {
    if (this.socketOpen && this.webSocket) {
      const mess = {
        type: 'detach',
        token: this.token,
      };

      this.webSocket.send(JSON.stringify(mess));
      // console.log('Detaching webSocket')
    }
  }

  public reOpenSocket() {
    this.token = window.localStorage[CONFIG.TOKEN_NAME];
    if (!this.token) {
      // console.error('No token - cannot re init web socket');
      return;
    }
    if (this.socketOpen) {
      const mess = {
        type: 'init',
        token: this.token,
      };

      if (this.webSocket) {
        this.webSocket.send(JSON.stringify(mess));
        // console.log('re-init webSocket')
      }
    } else {
      this.openSocket();
      // console.log('reopened socket?');
    }
  }

  public sendEvent = (name: string, message: any) => {
    const ev = new CustomEvent(name, {detail: {message: message}});
    this.eventEl.dispatchEvent(ev);
  }


  /**
   * @returns {WebSocketClient}
   */
  static getInstance(): WebSocketClient {
    if (WebSocketClient.myInstance == null) {
      WebSocketClient.myInstance = new WebSocketClient();
    }
    return this.myInstance;
  }
}
